import { WorksheetBatchUpdateTestStatusQueryField } from './WorksheetBatchUpdateTestStatusQueryField';
import { WorksheetBatchUpdateWorkOrderQueryField } from './WorksheetBatchUpdateWorkOrderQueryField';

export const WorksheetBatchUpdateCommonQueryFields = {
  WorkOrder: WorksheetBatchUpdateWorkOrderQueryField,
  WorksheetStatus: WorksheetBatchUpdateTestStatusQueryField,
};

export const WorksheetBatchUpdateCommonDefaultParams = {};

export const WorksheetBatchUpdateCommonRequiredParams = ['WorkOrder'];
